import { cn } from '@/lib/utils';

export type DividerProps = {
  alignment?: 'horizontal' | 'vertical';
  showOnDark?: boolean;
  classNames?: {
    root?: string;
  };
};

export function Divider({
  alignment = 'horizontal',
  showOnDark = false,
  classNames,
}: DividerProps) {
  const classesStyles = {
    horizontal: 'w-full border-t',
    vertical: 'h-full border-l',
  }[alignment];

  return (
    <div
      className={cn(
        'border-grey-500 border-solid',
        !showOnDark && 'dark:hidden',
        classesStyles,
        classNames?.root
      )}
    />
  );
}
